export function typeguardGenerator<T extends ReadonlyArray<string>>(kind: T) {
  return function (value: unknown): value is typeof kind[number] {
    return typeof value === 'string' && !!kind.includes(value)
  }
}
